// extracted by mini-css-extract-plugin
export default {"title":"Contact_title__6kEjN","container":"Contact_container__J1LZ1","icon":"Contact_icon__uPRlS","section":"Contact_section__9Wxix","card":"Contact_card__uJftK"};